import React from "react";
import { Button } from "@/components/ui/button";
import { Save, Mail, Download, FileSpreadsheet } from "lucide-react";
interface ProjectActionsProps {
  isSaving: boolean;
  isSendingEmail: boolean;
  onSave: () => Promise<void>;
  onSendEmail: () => Promise<void>;
  onExportPDF: () => void;
  onExportExcel: () => void;
}
const ProjectActions: React.FC<ProjectActionsProps> = ({
  isSaving,
  isSendingEmail,
  onSave,
  onSendEmail,
  onExportPDF,
  onExportExcel
}) => {
  return <div className="flex gap-2">
      <Button onClick={onSave} disabled={isSaving} className="bg-purple-600 hover:bg-purple-700 text-white">
        <Save className="mr-2 h-4 w-4" />
        {isSaving ? "Saving..." : "Save Estimate"}
      </Button>
      <Button onClick={onSendEmail} disabled={isSendingEmail} className="bg-blue-600 hover:bg-blue-700 text-white">
        <Mail className="mr-2 h-4 w-4" />
        {isSendingEmail ? "Sending..." : "Email Report"}
      </Button>
      
      <Button onClick={onExportExcel} className="bg-yellow-600 hover:bg-yellow-700 text-white">
        <FileSpreadsheet className="mr-2 h-4 w-4" />
        Export to Excel
      </Button>
    </div>;
};
export default ProjectActions;